// extracted by mini-css-extract-plugin
module.exports = {"footerDefault":"styles_footerDefault__1fEzv","row":"styles_row__tBiY7","backdropLogo":"styles_backdropLogo__9nbIs","copyright":"styles_copyright__13YbJ"};